<template>
    <div class="order-item" @click.stop="selected">
        <div class="content">
            <div class="title">{{ order.first_location.alias || order.first_location.road }}</div>
            <div class="name">#{{ order.designated_driver.knight_id }} {{ order.designated_driver.name }}</div>
        </div>
        <div class="avatar" :style="avatarStyle"/>
    </div>
</template>

<script>
    export default {
        name: "OrderItem",
        props: {
            order: {
                require: true,
                type: Object,
            }
        },
        computed: {
            avatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.order.designated_driver.avatar) {
                    url = this.order.designated_driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
        },
        methods: {
            selected() {
                this.$router.push({
                    name: 'order',
                    params: {
                        id: this.order.id,
                        designate: true,
                        name: this.$route.name,
                        designate_type: this.$route.params.type,
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .order-item {
        border-right: 5px;
        background-color: #fff;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 15px;
        display: flex;
        user-select: none;
        cursor: pointer;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        .content {
            display: flex;
            flex-direction: column;
            text-align: left;
            flex: 1;

            .title {
                color: #000000;
                font-size: 14px;
            }

            .name {
                margin-top: 5px;
                color: #4a4a4a;
                font-size: 12px;
            }
        }

        .avatar {
            height: 40px;
            width: 40px;
            border-radius: 90px;
            background-position: 50% 50%;
            background-size: cover;
            margin-left: 15px;
        }
    }
</style>